import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";

type Props = {};

const Base = ({ children }: RequireChildrenFor<Props>) => {
    const { isEveryDayLowPrice } = useECommerceProduct();

    if (!isEveryDayLowPrice) return null;

    return children;
};

export { Base };
